'use client';

import { FC, PropsWithChildren, useEffect, use } from 'react';
import { useRouter } from 'next/navigation';
import { useGetOrderType } from '@ordering/stores/OrderStore/hooks';
import { useFeatures } from '@ordering/providers/FeaturesProvider';

const Layout: FC<
  PropsWithChildren<{
    params: Promise<{
      merchantCode: string;
      locationCode: string;
    }>;
  }>
> = (props) => {
  const params = use(props.params);

  const { children } = props;

  const orderType = useGetOrderType();
  const { isOrderAndPayStore } = useFeatures();
  const router = useRouter();
  useEffect(() => {
    if (!orderType && isOrderAndPayStore) {
      router.replace(`/${params.merchantCode}/${params.locationCode}/order-type`);
    }
  }, [orderType, isOrderAndPayStore, params.locationCode, params.merchantCode, router]);

  return <>{children}</>;
};

export default Layout;
